const explanationTranslations = {
  tabWorkout: "Workout",
  tabNutirition: "Nutirition",
  explainationPopUp: {
    cancel: "Cancel",
  },
};

export default explanationTranslations;
